import { Box, Card, Grid } from "@mui/material";
import { useState } from "react";
import { DisclosureHost } from "../../../hooks/use-disclosure";
import Flex from "../../Flex";
import StyledDialog from "../../StyledDialog";
import Text from "../../Text";
import csvColor from "/public/csv-color.svg";
import csvDisable from "/public/csv-disable.svg";
type CardValue = "ehr" | "csv" | "patient";
// import ehrColor from "/public/ehr-color.svg";
// import ehrDisable from "/public/ehr-disable.svg";
import StyledButtonV2 from "../StyledButtonV2";
import patientColor from "/public/patient-color.svg";
import patientDisable from "/public/patient-detail-disable.svg";

type Card = {
  value: CardValue;
  name: string;
  active: string;
  disable: string;
};

interface NavAddPatientModalProps {
  disclosureHost: DisclosureHost;
  onNextClick: (v: CardValue | null) => void;
}

const CARD_DATA: Card[] = [
  // {
  //   name: "Import From EHR",
  //   value: "ehr",
  //   active: ehrColor,
  //   disable: ehrDisable,
  // },
  {
    name: "Upload CSV File",
    value: "csv",
    active: csvColor,
    disable: csvDisable,
  },
  {
    name: "Enter Patient Details",
    value: "patient",
    active: patientColor,
    disable: patientDisable,
  },
];

const NavAddPatientModal = ({
  disclosureHost,
  onNextClick,
}: NavAddPatientModalProps) => {
  const [curActiveCard, setCurActiveCard] = useState<CardValue | null>(null);
  return (
    <StyledDialog
      open={disclosureHost.opened}
      dialogTitle={"Add Patient"}
      onClose={() => {
        disclosureHost.close();
        setCurActiveCard(null);
      }}
      dialogAction={
        <Flex gap={"20px"}>
          <StyledButtonV2
            label="Next"
            sx={{ width: "6.25rem" }}
            onClick={() => onNextClick(curActiveCard)}
            variant="contained"
            disabled={!curActiveCard}
          />
        </Flex>
      }
    >
      <Box width={"26.75rem"} mt={"5rem"} style={{ height: "240.5px" }}>
        <Grid container spacing={3}>
          {CARD_DATA?.map((it, idx) => (
            <Grid
              key={idx}
              style={{ cursor: "pointer" }}
              item
              xs={6}
              onClick={() => {
                it.value === "ehr" ? undefined : setCurActiveCard(it.value);
              }}
              width="180px"
            >
              {it.value === curActiveCard ? (
                <img src={it.active} />
              ) : (
                <img src={it.disable} />
              )}
              <Text
                px={"2rem"}
                mt={"10px"}
                textAlign={"center"}
                fontWeight={it.value === curActiveCard ? "medium" : "normal"}
              >
                {it.name}
              </Text>
            </Grid>
          ))}
        </Grid>
      </Box>
    </StyledDialog>
  );
};

export default NavAddPatientModal;
